import React, {useContext, useState } from 'react'
import { UserContext } from '../../context/UserContext';
import PurchaseCategoryManager from './PurchaseCategoryManager';
import PurchaseCustomModal from './PurchaseCustomModal';
import { enviarCobro, olvidarClaveCobro, AVISO_COBRO_LENTO } from '../../lib/helpers/claveIdempotencia';

const PurchaseModal = ({ active, handlePurchaseModal, user_id, id, setErrorMessage, costLine }) => {
    // UserContext es POSICIONAL: [0] token, [3] venueID. El venue hace falta para la
    // clave de idempotencia del cobro (se guarda por local y ámbito).
    const [token, , , venueID] = useContext(UserContext);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantity, setQuantity] = useState("");
    const [price, setPrice] = useState(null);

    // const [selectedPrice, setSelectedPrice] = useState(null);

    const handleProductSelect = (productId) => {
        // You could also fetch product details here if needed
        setSelectedProduct(productId);
        };

    const handleProductPrice = (priceValue) => {
        // You could also fetch product details here if needed
        setPrice(priceValue);
        };

    const purchase = async () => {
        if (!selectedProduct) {
            setErrorMessage("No product selected.");
            return;
          }
        const cuerpo = {
            // SIN cart_type, a propósito: esto es una venta SUELTA de un producto
            // elegido aquí mismo, no "cobrar su carrito". Con cart_type el backend
            // consumiría (borraría) el borrador aparcado del socio — el carrito que
            // el camarero está montando en Carritos desaparecería en silencio por
            // una venta que no tiene nada que ver. Cobrar carritos es cosa de la
            // pantalla Carritos, que sí lo manda. (Decisión 20-ago-2026, análisis
            // del reporte de carros duplicados; hay candado que lo fija.)
            user_id: user_id,
            // `venue_id` es obligatorio en `CreatePurchaseRequest`: sin él esto era un
            // 422 seguro. No se notaba porque la pantalla está inalcanzable — nadie
            // llama a `setPurchaseModal(true)` en Customers.jsx.
            venue_id: venueID,
            shop_id: 236,
            type: "purchase",
            amount: quantity,
            status: "string",
            id: 0,
            timestamp: "2024-04-07T18:07:37.706Z",
            items: [
              {
                product_id: selectedProduct,
                quantity: quantity,
                unit_price: price,
                id: 0,
                transaction_id: 0
              }
            ]
        };
        try {
            // Con clave de idempotencia: esta venta suelta cobraba a pelo, y al terminar
            // recarga la página entera — si la petición se queda colgada, lo natural es
            // volver a darle, y eso cobraba dos veces (Kong House, 13-09 y 24-09-2026).
            const response = await enviarCobro({
                token,
                venueId: venueID,
                ambito: 'venta-suelta',
                huella: JSON.stringify([user_id, selectedProduct, quantity, price]),
                cuerpo,
            });
            if (!response.ok) throw await response.json();
            olvidarClaveCobro(venueID, 'venta-suelta');
            window.location.reload();
        } catch (error) {
            if (error?.name === 'AbortError') {
                setErrorMessage(AVISO_COBRO_LENTO);
                return;
            }
            setErrorMessage(error.detail || 'An error occurred during registration.');
        }
    };

    // Submit registration
    const handleSubmit = (e) => {
          e.preventDefault();
          purchase();

      };

    const modalContent = (
        <>
        <div className="flex flex-row gap-4 w-full">
        <PurchaseCategoryManager 
            costLine={costLine}
            onProductSelect={handleProductSelect} 
            onPriceValue={handleProductPrice}

        />
        </div>
        <form onSubmit={handleSubmit} className="space-y-6 p-4">
            <div className="quantity">
                <label htmlFor="quantity" className="block text-sm font-medium text-gray-700">Quantity</label>
                <input
                    type="text"
                    id="quantity"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                    className="mt-1 px-3 py-2 bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full"
                    required
                />
            </div>
          <div className="flex items-center justify-between">
            
            <button
              type="submit"
              className="w-full inline-flex justify-center
               rounded-md border border-transparent 
               shadow-sm px-4 py-2 bg-blue-600 text-base font-medium
                text-white hover:bg-blue-700 focus:outline-none focus:ring-2 
                focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
            >
              { 'Purchase'}
            </button>
          </div>
        </form>
        </>
      );



  return (
    <PurchaseCustomModal
      active={active}
      handleModal={handlePurchaseModal}
      title={id ? 'Pursschase' : 'Purchase'}
    >
      <div className="w-3/4 mx-auto">{modalContent}</div>
    </PurchaseCustomModal>
  )
}

export default PurchaseModal;
